import { useRef } from "react";
import ro from "/src/content/ro.json";

const DespreStefan = () => {
  const videoRef = useRef(null);

  const handlePlay = () => {
    if (!videoRef.current) return;
    if (videoRef.current.paused) videoRef.current.play();
    else videoRef.current.pause();
  };

  return (
    <section className="sectiune-stefan" id="despre">
      <div className="despre-container">
        {/* HEADER */}
        <header className="despre-header">
          <h1 className="despre-title">{ro.about.title}</h1>
          <p className="despre-kicker">{ro.about.kicker}</p>
        </header>

        {/* GRID 2 COLOANE */}
        <div className="despre-grid">
          {/* 🟡 Coloana 1 — text */}
          <div className="despre-text">
            <p>{ro.about.text1}</p>
            <p>{ro.about.text2}</p>
          </div>

          {/* 🔵 Coloana 2 — video */}
          <div className="despre-video">
            <div className="video-wrap">
              <video
                ref={videoRef}
                src="/videos/video1.mp4"
                muted
                loop
                playsInline
                onClick={handlePlay}
                className="cursor-pointer block"
              />
              <img
                src="/images/cursor-click.svg"
                alt={ro.about.cursorAlt}
                className="cursor-icon"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DespreStefan;
